module.exports = __webpack_public_path__ + "media/luxury-2026/formal-exterior-960-870d5935.jpg";